import { ComponentFactory, ComponentFactoryResolver, EventEmitter, Injectable, Output, Type } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';

import { AnagraficaNavigations, messagefromComponent, TAB, TABPANEL } from '../class/appinterface'
import { OverlaySideFormService } from '../components/shared/overlay-side-form/overlay-side-form.service';
import { warn } from 'console';
@Injectable({
  providedIn: 'root'
})



export class ComponentService {
  private _closeOverlayForm: Subject<boolean>;
  @Output() dataFromComponent: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private _componentFactoryResolver: ComponentFactoryResolver,
    private overlaySideService: OverlaySideFormService,
    private activateRoute: ActivatedRoute
  ) {
    this._closeOverlayForm = new Subject<boolean>();
  }



  //private _overlayClose = new BehaviorSubject<any>('');
  //overlayClose = this._overlayClose.asObservable();

  private message = new BehaviorSubject<any>('');
  private _tabIndex = new BehaviorSubject<number>(0);
  private _tabs = new BehaviorSubject<any>('');
  private _currentTabs = new BehaviorSubject<any>('');

  private _componentRouter = new BehaviorSubject<AnagraficaNavigations[]>([]);

  private _numberOfNav: BehaviorSubject<any> = new BehaviorSubject<any>('');
  public numberOfNav = this._numberOfNav.asObservable();

  private _helpNDoc = new BehaviorSubject<any[]>([])

  private _popupsSet = new BehaviorSubject<any[]>([])
  popupsSet = this._popupsSet.asObservable();
  currentPopupsSet: any[] = [];

  private _outputComponent = new BehaviorSubject<any>([]);
  outputComponent = this._outputComponent.asObservable();
  //setOutputComponent


  private eventoToolbarSubject = new Subject<string>();
  eventoToolbarObs$ = this.eventoToolbarSubject.asObservable();

  eventoToolbarEmit(event: string) {
    this.eventoToolbarSubject.next(event);
  }




  tabs = this._tabs.asObservable();
  //tabSeted = this._tabSeted.asObservable();
  castMessage = this.message.asObservable();
  tabIndex = this._tabIndex.asObservable();

  tabsSeted: TABPANEL[] = [];
  currentTabs = this._currentTabs.asObservable();

  navComponent: AnagraficaNavigations[] = []
  componentRouter = this._componentRouter.asObservable();

  helpNDoc = this._helpNDoc.asObservable()



  closeOverlayForm() {
    return this._closeOverlayForm.asObservable();
  }

  emitMessage(message: messagefromComponent) {
    this.message.next(message);
  }
  ngOnDestroy() {
    this.message.unsubscribe()

  }
  destroyMessage() {
    this.message.next([]);

  }
  setTabs(name: string, tabsJson: TAB[]) {

    this.activateRoute.queryParams.subscribe(params => {
      tabsJson.forEach(tab => {
        tab.paramsUrl = params
      })

    })


    this.destroyTabs(name)
    let cc = [{
      tabIndex: tabsJson.length - 1,
      name: name,
      dati: tabsJson,
      action: 'set'
    }]




    this._currentTabs.next(cc)

    this.tabsSeted.push({
      tabIndex: tabsJson.length - 1,
      name: name,
      dati: tabsJson,
      action: 'set'
    })


    this._tabs.next(this.tabsSeted);

  }

  addNewTab(name, newItem) {




    let action = 'add'
    let tabsSel: TABPANEL[];
    tabsSel = this.setActiveTabsByName(name); //SEleziono la tab dove aggiungere l'elemento
    let tabIndex = tabsSel.filter(tab_name => tab_name.tabIndex);

    /*  //console.log(tabIndex)
     
  
  
      return */
    let currentTabs = tabsSel;
    newItem.map((tabToAdd: TAB) => {

      currentTabs.filter(tab_name => { return tab_name.name == name });
      ////console.log('currentTabs',currentTabs)
      let ele = this.findTab(tabsSel, tabToAdd);

      if (ele > 0) {
        currentTabs.map(mapped => {
          action = 'update'
          mapped.dati.splice(ele, 1);

        })

      }



      currentTabs.map(mapped => {
        mapped.dati.push(tabToAdd);
        mapped.action = action;
      })

      ////console.log(currentTabs);
      ////console.log(tabsSel);

      this._currentTabs.next(currentTabs)


      this._tabs.next(tabsSel)
    })



    //
    //this._tabInfo.next(newItem);
    //this.selectedTab(currentTabs.dati,newItem[0]);
    // 
    // 



  }

  apriLinkEsterno(link) {
    if (!link.includes('https://') && !link.includes('http://')) {
      return window.open(`https://${link}`, '_blank');
    } else {
      window.open(link, '_blank');
    }
  }

  findTab(tabsel, tCntr) {

    let checkIndex = 0;
    tabsel.forEach(tab => {

      checkIndex = tab.dati.findIndex(val => { return val.id == tCntr.id });

    });

    return checkIndex;
  }

  setActiveTabsByName(nameTabs) {



    let setActiveTabs = this.tabsSeted.filter(tabPanel => { return tabPanel.name == nameTabs });
    //this._currentTabs.next(setActiveTabs)
    return setActiveTabs
  }

  setCurrentTabPanel(nameTabs) {

    let setActiveTabs = this.tabsSeted.filter(tabPanel => { return tabPanel.name == nameTabs });
    this._currentTabs.next(setActiveTabs)

  }

  selectedTab(tabs, itm) {

    let index = tabs.findIndex(value => { return value.id == itm.id });
    this._tabIndex.next(index);

  }

  selectTab(tabs, itm) {

    tabs.forEach(tab => {


    })
    let index = tabs.findIndex(value => { return value.id == itm.id });
    this._tabIndex.next(index);

  }

  destroyTabs(name = '') {


    this.tabsSeted.map((setT, key) => {

      if (setT.name == name) {


        this.tabsSeted.splice(key, 1)
      }

    })


    this._tabs.next(this.tabsSeted);
    //this._tabs.pipe
  }



  setNavComponent(nav) {
    this.navComponent = nav;
    this._componentRouter.next(this.navComponent);
  }

  setOpzionalParameter(key, value, currentTabId) {
    let arrNavObj = [];
    let arrNav = sessionStorage.getItem('currentTabsData');
    if (arrNav) arrNavObj = JSON.parse(arrNav);
    let index = -1;
    if (arrNavObj) {
      index = arrNavObj.findIndex(res => {
        return res.currentTabId == currentTabId;
      })
    }

    if (index > -1) {
      arrNavObj[index][key] = value
      sessionStorage.setItem('currentTabsData', JSON.stringify(arrNavObj));
    } else {
      let x = {
        currentTabId: currentTabId,
        [key]: value
      }
      arrNavObj.push(x)
      sessionStorage.setItem('currentTabsData', JSON.stringify(arrNavObj));
    }
  }
  removeOptionalParameter(currentTabId) {
    let arrNavObj = [];
    let arrNav = sessionStorage.getItem('currentTabsData');
    arrNavObj = JSON.parse(arrNav);
    let index = -1;
    if (arrNavObj) {
      index = arrNavObj.findIndex(res => {
        return res.currentTabId == currentTabId;
      })
    }
    if (index > -1) {
      arrNavObj.splice(index, 1)
      sessionStorage.setItem('currentTabsData', JSON.stringify(arrNavObj))
    }
  }

  getOpzionalParameter(key, currentTabId) {
    let arrNavObj = [];
    let arrNav = sessionStorage.getItem('currentTabsData');
    arrNavObj = JSON.parse(arrNav);
    let index = -1;
    if (arrNavObj) {
      index = arrNavObj.findIndex(res => {
        return res.currentTabId == currentTabId;
      })
    }
    if (index > -1) {
      if (arrNavObj[index][key]) return arrNavObj[index][key]
    } else return null
  }



  setComponentNavigation(cNav) {
    if (typeof cNav.idTab != 'undefined') {
      const currentNav = this.getCurrentRouterNav(cNav.idTab)

      ////console.log(currentNav);

      if (currentNav.length == 0) {



        this.navComponent.push({
          idTab: cNav.idTab,
          data: [{
            id: cNav.idData,
            title: cNav.title,
            cRouter: cNav.cRouter,
            params: cNav.params,
            currentComponent: cNav.currentComponent,
            activeCurrent: cNav.active,
            idGroup: cNav.idGroup,
            items: []

          }]


        })
      } else {
        let index = currentNav[0].data.findIndex(res => {
          return res.id == cNav.idData;
        }
        );
        if (index < 0 && typeof cNav.title != 'undefined') {
          currentNav[0].data.push({
            id: cNav.idData,
            title: cNav.title,
            cRouter: cNav.cRouter,
            params: cNav.params,
            currentComponent: cNav.currentComponent,
            activeCurrent: cNav.active,
            idGroup: cNav.idGroup,
            items: []

          })
        } else {
          if (currentNav[0].data[index]) {
            currentNav[0].data[index].id = cNav.idData
            currentNav[0].data[index].title = cNav.title
            currentNav[0].data[index].cRouter = cNav.cRouter;
            currentNav[0].data[index].params = cNav.params;
            currentNav[0].data[index].currentComponent = cNav.currentComponent;
            currentNav[0].data[index].activeCurrent = cNav.activeCurrent;
            currentNav[0].data[index].idGroup = cNav.idGroup;




          }


          //console.log(currentNav[0].data[index])
        }

      }
      this._componentRouter.next(this.navComponent);
      sessionStorage.setItem('navComponent', JSON.stringify(this.navComponent))
    }


  }


  setNavigationChildren(cNav, idGroup) {

    const currentNav = this.getCurrentRouterNav(cNav.idTab)


    let index = currentNav[0].data.findIndex(res => {
      return res.id == idGroup;
    })
    if (currentNav[0].data[index].id === cNav.idData) {
      currentNav[0].data[index].params = cNav.params
    }

    let i = currentNav[0].data[index].items.findIndex(cItems => cItems.id == cNav.idData);


    if (i < 0) {
      currentNav[0].data[index]['items'].push({

        title: cNav.title,
        cRouter: cNav.cRouter,
        params: cNav.params,
        idGroup: cNav.idGroup,
        idTab: cNav.idTab,
        id: cNav.idData,
        active: true,
      })

    } else {
      currentNav[0].data[index].items[i] = {
        id: cNav.idData,
        title: cNav.title,
        cRouter: cNav.cRouter,
        params: cNav.params,
        currentComponent: cNav.currentComponent,
        activeCurrent: cNav.activeCurrent,
        idGroup: cNav.idGroup
      }

    }
    this._componentRouter.next(this.navComponent);

    //console.log('navComponent',this.navComponent)
    sessionStorage.setItem('navComponent', JSON.stringify(this.navComponent))
  }

  removeChildren(id, idGroup, idTab) {
    const currentNav = this.getCurrentRouterNav(idTab)


    let index = currentNav[0].data.findIndex(res => {
      return res.id == idGroup;
    })
    let i = currentNav[0].data[index].items.findIndex(cItems => cItems.id == id);
    currentNav[0].data[index]['items'] = [];

    this._componentRouter.next(this.navComponent);

    //console.log('navComponent',this.navComponent)
  }


  getCurrentRouterNav(idTab) {
    return this.navComponent.filter(res => res.idTab == idTab)
  }

  show() {

  }

  openComponentCustom(componentName, dataToSend: any, Title: string, w = 1260, h = 700, showToolBarBottom = true) {

    if (typeof componentName == 'undefined') {
      return
    }


    const factories = Array.from(this._componentFactoryResolver['_factories'].keys());
    const factoryClass = <Type<any>>factories.find((x: any) => x.name === componentName);
    const componentFactory: ComponentFactory<any> = this._componentFactoryResolver.resolveComponentFactory(factoryClass);
    this.overlaySideService.setTitle(Title);
    this.overlaySideService.setContent(factoryClass);
    this.overlaySideService.sendDataToComponent(dataToSend);
    this.overlaySideService.setToolBarVisible(showToolBarBottom)
    this.overlaySideService.setPopupWidth(w);
    this.overlaySideService.setPopupHeight(h);
    setTimeout(() => {
      if (typeof this.overlaySideService === 'undefined') {
        //return
      }
      else {
        this.overlaySideService._hrefComponent.instance.class = 'soggetto-form';
        this.overlaySideService._hrefComponent.instance.emitData.subscribe(x => {
          this.dataFromComponent.emit(x); // emette dati al componente chimante
          //let Risp={key:componente,value:x}       
        })

      }
    }, 500);
    this.overlaySideService.show();


    this.overlaySideService.onPanelClose().subscribe(res => {
      this._closeOverlayForm.next(true);

      //let Risp={key:componente,value:this.overlaySideService._hrefComponent.instance.dataCallBack}
      //if(callBack)
      //callBack(Risp);
    })



  }

  openComponent(componentName, dataToSend: any, Title: string, w = 1260, h = 500, callBack = null, componente = null) {

    if (typeof componentName == 'undefined') {
      return
    }


    const factories = Array.from(this._componentFactoryResolver['_factories'].keys());
    const factoryClass = <Type<any>>factories.find((x: any) => x.name === componentName);
    const componentFactory: ComponentFactory<any> = this._componentFactoryResolver.resolveComponentFactory(factoryClass);
    this.overlaySideService.setTitle(Title);
    this.overlaySideService.setContent(factoryClass);
    this.overlaySideService.sendDataToComponent(dataToSend);
    this.overlaySideService.setToolBarVisible(false)
    this.overlaySideService.setPopupWidth(w);
    this.overlaySideService.setPopupHeight(h);
    setTimeout(() => {
      if (typeof this.overlaySideService === 'undefined') {
        //return
      }
      else {
        this.overlaySideService._hrefComponent.instance.class = 'soggetto-form';
        this.overlaySideService._hrefComponent.instance.emitData.subscribe(x => {
          this.dataFromComponent.emit(x); // emette dati al componente chimante
          let Risp = { key: componente, value: x }
        })

      }
    }, 500);
    this.overlaySideService.show();


    this.overlaySideService.onPanelClose().subscribe(res => {
      this._closeOverlayForm.next(true);

      //let Risp={key:componente,value:this.overlaySideService._hrefComponent.instance.dataCallBack}
      //if(callBack)
      //callBack(Risp);
    })



  }

  getItemsRouterComponentNavigation(id, currentTabId) {

    const currentNav = this.getCurrentRouterNav(currentTabId)
    console.log('getItemsRouterComponentNavigation', currentNav)
  }

  getPrevItemComponentNavigation(id, currentTabId) {
    if (this.navComponent.length > 0) {
      const currentNav = this.getCurrentRouterNav(currentTabId);
      const currentItemIndex = currentNav[0].data.findIndex(items => items.id == id) - 1;
      //console.log('getPrevItemComponentNavigation',currentItemIndex)
      if (currentItemIndex > 0) {
        return currentNav[0].data[currentItemIndex]
      }

      //currentNav[0].data.splice(-1);
      //this.navComponent.splice(-1);
      //this._componentRouter.next(currentNav)
    }

  }

  removeLastItemComponentNavigation(currentTabId) {
    if (this.navComponent.length > 0) {
      const currentNav = this.getCurrentRouterNav(currentTabId)


      currentNav[0].data.splice(-1);
      sessionStorage.setItem('navComponent', JSON.stringify(currentNav))
      /* const allElementLength=currentNav[0].data.length  - 1
      //this.navComponent.splice(-1);
      this._componentRouter.next(currentNav) */
    }

  }

  removeItemComponentNavigation(id, currentTabId) {
    if (this.navComponent.length > 0) {
      const currentNav = this.getCurrentRouterNav(currentTabId);
      const currentItemIndex = currentNav[0].data.findIndex(items => items.id == id);
      //console.log('removeItemComponentNavigation',currentItemIndex)
      if (currentItemIndex >= 1) {
        currentNav[0].data.splice(currentItemIndex, 1);
      }
      //currentNav[0].data.splice(-1);
      //this.navComponent.splice(-1);
      this._componentRouter.next(currentNav);
      sessionStorage.setItem('navComponent', JSON.stringify(currentNav))
    }


  }

  removeItemComponentNavigationSede(id, currentTabId) {

    if (this.navComponent.length > 0) {
      const currentNav = this.getCurrentRouterNav(currentTabId);
      const currentItemIndex = currentNav[0].data.findIndex(items => items.id == id);
      ////console.log('removeItemComponentNavigation',currentItemIndex)
      if (currentItemIndex > 0) {
        currentNav[0].data.splice(currentItemIndex, 1);
      }


      //currentNav[0].data.splice(-1);
      //this.navComponent.splice(-1);
      //this._componentRouter.next(currentNav)
    }

  }

  removeAllItemComponentFromID(id, currentTabId) {
    if (this.navComponent.length > 0) {
      const currentNav = this.getCurrentRouterNav(currentTabId);
      if (currentNav.length > 0) {
        const currentItemIndex = currentNav[0].data.findIndex(items => items.id == id);

        if (currentItemIndex >= 0) {
          const allElementLength = currentNav[0].data.length - 1
          currentNav[0].data.splice(currentItemIndex, allElementLength);
        }
      }


    }

  }

  removeNavigationComponent(id, currentTabId) {
    if (this.navComponent.length > 0) {

      const currentNav = this.getCurrentRouterNav(currentTabId);
      const currentItemIndex = this.navComponent.findIndex(items => items.idTab == currentTabId);
      this.navComponent.splice(currentItemIndex, 1)
      this._componentRouter.next(this.navComponent);
      sessionStorage.setItem('navComponent', JSON.stringify(this.navComponent))
    }

  }

  destroyComponentNavigation() {

    this.navComponent = [];
    this._componentRouter.next(null);

    this.componentRouter.subscribe(re => {
      ////console.log(re)
    })
  }

  destroyComponentNavigationTab(currentTabId) {

    /*this.navComponent = [];
    this._componentRouter.next(null);*/

    if (this.navComponent.length > 0) {
      const currentNav = this.navComponent.findIndex(res => res.idTab == currentTabId)
      //this.getCurrentRouterNav(currentTabId);
      this.navComponent.splice(currentNav, 1);
      //console.log('currentNavIndex',this.navComponent);

      sessionStorage.removeItem('navComponent')

      /*const currentItemIndex = currentNav[0].data.findIndex(items=>items.id == id);
      currentNav[0].data.splice(currentItemIndex, currentNav[0].data.length);*/

    }
  }

  enableHelpNDoc(data) {
    this._helpNDoc.next(data)
  }


  apic(value) {
    return "'" + value + "'"
  }

  /**********Gestione PopUp **********/

  setNewPopUp(id, componentName, data, popUpWidth = '', accessoringData?, instancedData?, showCaptionFooter = false, showCaptionHeader = false, title = '', position?, help?, popupHeight?) {
    if (typeof componentName == 'undefined' || !id) {
      return
    }
    //console.log('setNewPopUp',this.currentPopupsSet)

    if (!help) {
      help = null
    }
    if (!position) {
      position = 'center'
    }

    let index = this.currentPopupsSet.findIndex(rrrr => rrrr.id == id && rrrr.componentName == componentName)
    if (index < 0) {
      let dataPoUp = {
        componentName: componentName,
        dataToSend: data,
        instancedData: instancedData,
        popUpWidth: popUpWidth,
        showCaptionFooter: showCaptionFooter,
        showCaptionHeader: showCaptionHeader,
        accessoringData: accessoringData,
        action: 'added',
        title: title,
        position: position,
        id: id,
        help: help,
        popupHeight: popupHeight
      }
      this.currentPopupsSet.push(dataPoUp)
      this._popupsSet.next(this.currentPopupsSet);

    } else {

      // dataPoUp.action = 'update'

      this.currentPopupsSet[index]['dataToSend'] = data;
      this.currentPopupsSet[index]['action'] = 'update';

      // this.currentPopupsSet[index]['id'] = id;
      this.currentPopupsSet[index]['showCaptionFooter'] = showCaptionFooter;
      this.currentPopupsSet[index]['showCaptionHeader'] = showCaptionHeader;


      this._popupsSet.next(this.currentPopupsSet);
    }



  }
  setPopUps(popUps) {

    this.currentPopupsSet = popUps

    //this._popupsSet.next(this.currentPopupsSet);
  }

  destroyCurrentOpenPopUp(componentName) {

    let arrayEl = this.currentPopupsSet.filter(rrrr => rrrr.componentName == componentName)

    if (arrayEl.length > 0) {

      arrayEl.forEach((el, index) => {
        this.destroyCurrentOpenPopUpByGuid(el.id);

        /* this.currentPopupsSet.splice(index,1);
        this._popupsSet.next(this.currentPopupsSet);
        try{
  
          document.getElementsByClassName('modal').item(index).classList.remove('slide-center');
          document.getElementsByClassName('modal').item(index).classList.add('fade-out-bck');
         // this._outputComponent.next([]);
    
    
          ;
        }catch(ex){
          console.warn(ex);
        } */
      })






    }


  }

  destroyCurrentOpenPopUpByGuid(id) {

    let index = this.currentPopupsSet.findIndex(rrrr => rrrr.id == id || rrrr.componentName == id)

    if (index >= 0) {


      this.currentPopupsSet[index].action = 'remove';

      try {

        document.getElementsByClassName('modal').item(index).classList.remove('slide-center');
        document.getElementsByClassName('modal').item(index).classList.add('fade-out-bck');

        this._popupsSet.next(this.currentPopupsSet);
        //this._outputComponent.next([]);


        this.currentPopupsSet.splice(index, 1)

        return true
      } catch (ex) {
        console.warn(ex);
        return false
      }





    }
    return false

  }

  destroyOutputComponent() {

    this._outputComponent.next([]);

  }

  destroyCurrentOpenPopUps() {
    this.currentPopupsSet = []
    this._popupsSet.next([]);
  }

  setOutputComponent(eventFromComponent) {
    this._outputComponent.next(eventFromComponent)
  }

  setNumberOfNav(nTabs) {


    this._numberOfNav.next(nTabs)

    //sessionStorage.setItem('numberOfNav', JSON.stringify(nTabs));
  }
}

